import { useAtomValue } from "jotai";
import { FormEvent } from "react";
import { pxToRem } from "theme";

import Button from "components/Button";
import Flex from "components/Flex";
import PageLayout from "components/PageLayout";
import VehicleImpact from "components/VehicleImpact";

import { isValidAtom, pointsOfImpactOrderedListAtom } from "atoms/pointsOfImpact";
import { useCheckpoint } from "hooks/useCheckpoint";
import { useClientTranslation } from "hooks/useClientTranslation";
import { usePageRouting } from "hooks/usePageRouting";
import { Checkpoint } from "types/Checkpoint";

import { PointOfImpactList } from "./PointOfImpactList";

export const DamageLocation = () => {
  const targetReached = useCheckpoint(Checkpoint.CLAIM_SUBMITTED);
  const selectedPoints = useAtomValue(pointsOfImpactOrderedListAtom);
  const isValid = useAtomValue(isValidAtom);
  const { onTrackAndNext, currentProgressStep, continueCTA } = usePageRouting();
  const { t } = useClientTranslation();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    onTrackAndNext({ name: "Damage area", properties: { damageArea: selectedPoints.join(", ") } })();
  };

  return (
    <PageLayout
      as="form"
      currentStep={currentProgressStep}
      onSubmit={handleSubmit}
      title={t("damage_area.header")}
      dataTestId="damageLocation"
      forceContinue={targetReached}
      bottomButtons={
        <Button disabled={!isValid} type="submit">
          {continueCTA}
        </Button>
      }
    >
      <Flex mx={24} mt={8} mb={32} style={{ minHeight: pxToRem[56] }}>
        <PointOfImpactList />
      </Flex>

      <VehicleImpact />
    </PageLayout>
  );
};
